<template>
  <div class="contact-wrapper">
    <!--<div id="map" style="width: 100%; height: 300px"></div>-->
    <div class="maps">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.9463174307866!2d30.33658351555005!3d40.7412067437649!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ccadf3b93b47db%3A0xaa82c42f614e5ca1!2sSakarya+Teknokent!5e0!3m2!1str!2str!4v1562686741903!5m2!1str!2str"
        width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
      <Modal2 :active="showSuccessMessage" @onModalClose="closeModal">
        <div slot="content">
          <div class="login-box mywidth" style="margin: 0 auto">
            <h2 class="login-box__title">YOUR MESSAGE SENT!</h2>
            <div class="or">
              <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
              <p><span>Thank you for your interets.</span></p>
            </div>
          </div>
        </div>
      </Modal2>
<Modal2 :active="showErrorMessage" @onModalClose="closeModalError">
   <div slot="content">
     <div class="login-box" style="margin: 0 auto">
    <h2 class="login-box__title2" >YOUR MESSAGE COULD NOT SENT!</h2>
    <div class="or">
      <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
      <p ><span class= "mycolorBlue">Unfortunately your mesage can not be send now</span></p>
      <p ><span class= "mycolorBlue">Please try again later.</span></p>
    </div>
     </div>
</div>
</Modal2>
    </div>
    <div class="section contact-section">
      <container>

       <div class="contact-section_gen text-left col-xl-10 offset-xl-1">
        <form id="myForm" @submit.prevent="submitForm">
          <div class="login-box">
            <h3 class="login-box__title"><span
              class="color-light-green">CONTACT FORM</span></h3>
            <v-input placeholder="Fullname" v-model="name"/>
            <label for="password" v-if="emptyName" class="myValidationText">Can not be leave empty!</label>
            <div class="login-box__left">
              <v-input placeholder="Telephone" v-model="phone"/>
              <label for="password" v-if="emptyPhone" class="myValidationText">Can not be leave empty!</label>
              <v-input placeholder="E-mail Address" v-model="email"/>
              <label for="password" v-if="emptyEmail" class="myValidationText">Can not be leave empty!</label>
            </div>
            <v-input placeholder="Messaje Subject" v-model="subject"/>
            <v-input placeholder="Message" class="textarea" v-model="message"/>
            <label for="password" v-if="emptyMessage" class="myValidationText">Can not be leave empty!</label>
            <v-button
              class="green fw shadow-none login-box__submit"
              title="SEND MESSAGE"
              v-if="messageEnabled"
              @click.native="sendMessage()"
            />
            <v-button
              class="green fw shadow-none login-box__submit"
              title="SENDING"
              v-else
            />            
           </div>
           <div class="contact-right">
            <div class="contact-right_gen">
              <div class="contact-right__item">
                <p class="contact-right__item-detail">
                  <img src="@/assets/img/printer.svg" class="contact-right__item-detail-img" alt="">support@holywoodskyline.com
                </p>
                <p class="contact-right__item-detail">
                  <img src="@/assets/img/contact.svg" class="contact-right__item-detail-img" alt="">0980 456 1239
                </p>
                <p class="contact-right__item-detail">
                  <img src="@/assets/img/address.svg" class="contact-right__item-detail-img" alt="">West Palm Beach, Florida, USA
                </p>
              </div>
              <div class="contact-right__item">

                <SocialGroup/>
              </div>
            </div>

          </div>
          </form>
        </div>
      </container>
    </div>
  </div>
</template>
<script>
  import SocialGroup from '@/components/SocialGroup'
  import Modal2 from '@/components/Modal2'
  import axios from 'axios'

  export default {
    name: 'Contact',
    components: {
      SocialGroup, Modal2
    },
    metaInfo () {
      return {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Contact',
        link: [
          { rel: 'canonical', href: window.location.origin + '/contact/' }
        ]
      }
    },
    data () {
      return {
        errors: [],
        messageEnabled: true,
        showSuccessMessage: false,
        showErrorMessage: false,
        name: null,
        phone: null,
        email: null,
        subject: '',
        message: '',
        emptyName: false,
        emptyMessage: false,
        emptyPhone: false,
        emptyEmail: false,
      }

    },
    methods: {
      submitForm() {

      },
      closeModal () {
        this.showSuccessMessage = false
      },
      closeModalError () {
        this.showErrorMessage = false
      },      
      sendMessage () {
        this.emptyName = false
        this.emptyMessage = false
        this.emptyPhone = false
        this.emptyEmail = false

        if (!this.name) {
          this.emptyName = true
        }
        if (!this.message) {
          this.emptyMessage = true
        }
        /*       if (!this.phone) {
                this.emptyPhone = true
              }
              if (!this.email) {
                this.emptyEmail = true
              }  */
        if (!this.emptyName && !this.emptyMessage) { // && !this.emptyEmail && !this.emptyMessage) {
          this.showErrorMessage = false
          this.messageEnabled = false
          var self = this
          axios.post(`/site/contact`, {
            name: this.name,
            email: this.email,
            message: this.message,
            phone: this.phone,
          })
            .then(response => {
              self.messageEnabled = true
              if (response.status === 200 || response.status === 201) {
                self.showSuccessMessage = true
              document.getElementById('myForm').reset()
              }
            })
            .catch(e => {
              this.showErrorMessage = true
              this.errors.push(e)
            })
        }
      }
    }
  }
</script>
<style lang="scss">
  @import "../assets/scss/components/contact";

  .mywidth {
    min-width: 400px;
  }
</style>
